<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.id) }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Ano/Mês</label>
                <div class="field-label field-label-center">{{ objView.anomes }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ objView.nmestabelecimento }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Atividade</label>
                <div class="field-label">{{ objView.nmatividade }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item-char15">
                <label class="label-caption">Digitação</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateTimeFromJson(objView.dhdigitacao) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Responsável</label>
                <div class="field-label">{{ objView.nmresponsavel }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">RT</label>
                <div class="field-label">{{ objView.nmrt }}</div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Quantidade Total</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.qtd_total) }}</div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Homologação</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateTimeFromJson(objView.dhhomologacao) }}</div>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">Situação</label>
                <div :class="objView.idstatus===9 ? 'field-label-alert' : 'field-label'">{{ objView.nmstatus }}</div>
            </div>
        </div>

        <div class="row-end">
            <button v-if="showBtnRetificar" type="button" class="btn-cancel" @click="abrirModal">Retificar</button>
            <button v-if="showBtnReabrir" type="button" class="btn-cancel" @click="abrirModal">Reabrir Digitação</button>
            <button type="button" @click="visualizarLaudo">Laudo</button>
            <button type="button" @click="closeForm">Retornar</button>
        </div>
    </div>

    <div class="form-edit-page">
        <table>
            <thead>
                <tr>
                    <th class="col-width-char10">Expedição</th>
                    <th class="col-width-char10">Código</th>
                    <th>Produto</th>
                    <th class="col-width-char40">Comprador</th>
                    <th class="col-width-char10">Unidade</th>
                    <th class="col-width-char15">Quantidade</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsItens" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtexpedicao) }}</td>
                    <td class="col-width-char10 right">{{ obj.cdproduto }}</td>
                    <td>{{ obj.nmproduto }}</td>
                    <td class="col-width-char40">{{ obj.comprador_nome }}</td>
                    <td class="col-width-char10 center">{{ obj.unidade }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.qtd) }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <ConfirmModal ref="confirmModal" />

    <DialogOkModal 
        v-if="showOkModal" 
        :message="'Reabertura realizada com sucesso'"
        @close="closeForm(true)" 
        @confirmed="closeForm(true)" />
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';

const emit = defineEmits(['close','save']);
const props = defineProps({idView: {type: Number, default: 0}});

const confirmModal = ref(null);
const isLoading = ref(false);
const lsItens = ref([]);
const msgAlerta=ref(null);
const objView = ref({});
const showBtnReabrir = ref(false);
const showBtnRetificar = ref(false);
const showOkModal = ref(false);

async function abrirModal() {
    const confirmado = await confirmModal.value.show({
        message: 'Confirma reabrertura da planilha para digitação?',
        confirmText: 'Sim',
        cancelText: 'Não'
    })

    if (confirmado) {
        reabrirDigitacao();   
    }
}

function closeForm(emitSave){
    if (emitSave==true) {emit('save');}
    emit('close');
}

const lerDados = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/lspla/plaexpedicao', {idep: globalStore.idep, id: props.idView});
        Object.assign(objView.value, req[0]);
        showBtnReabrir.value = ((objView.value.idstatus == 2 || objView.value.idstatus == 3) && (globalStore.ckperfilestabelecimento || globalStore.ckperfilrt));
        if (objView.value.idstatus===9 && globalStore.showAcoesEstabelecimento){
            // VALIDAR SE JÁ EXISTE PLANILHA RETIFICADORA
            showBtnRetificar.value = true;
        }
        
        const itens = await Api.genericPost('/lspla/plaexpedicao/itens', {id: props.idView});
        lsItens.value = itens;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}

async function reabrirDigitacao(){
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const response = await Api.genericPut('/cad/plaexpedicao', {
            id: objView.value.id, 
            idresponsavel: 0,
            nmresponsavel: "",
            idrt: 0,
            nmrt: "",
            dhdigitacao: "",
            lgdigitacao: 0});
        if (response.bolok === 1){
            showOkModal.value=true;
        }else{msgAlerta.value=`ATENÇÃO: ${response.erro}`;}
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

async function visualizarLaudo(){
    if (!objView.value.idlaudo){msgAlerta.value='Laudo não disponível!'; return;}
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const r = await Api.genericPost('/operacoes/solicitar/download', { id: objView.value.idlaudo });
        if (r.bolok === 1 && r.download_url) {
            window.open(r.download_url, '_blank');
        } else {
            msgAlerta.value = `ATENÇÃO: ${r.erro || 'Não foi possível abrir o anexo.'}`;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}

onMounted(lerDados);
</script>